(function () {
    'use strict';

    function entityConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/entityConfiguration.html',
            link: function (scope) {
            }
        };
    }

    entityConfiguration.$inject = [];

    angular.module('ecap.siteConfiguration').directive('entityConfiguration', entityConfiguration);
})();
